import { Injectable } from '@angular/core';
import { Observable, throwError } from 'rxjs';
import { catchError, tap } from 'rxjs/operators';
import { Router } from '@angular/router';
import { MatSnackBar } from '@angular/material/snack-bar';
import { AppConstants } from '../common/app.constants';
import { HttpEvent, HttpHandler, HttpInterceptor, HttpRequest, HttpErrorResponse, HttpResponse } from '@angular/common/http';


@Injectable({
  providedIn: 'root'
})
export class TokenInterceptorService implements HttpInterceptor {

  constructor(
    private router: Router,
    private snackBar: MatSnackBar
  ) { }

  intercept(
    request: HttpRequest<any>,
    next: HttpHandler
  ): Observable<HttpEvent<any>> {

    const token = sessionStorage.getItem(AppConstants.SESSION_VAR_TOKEN);

    if (!this.isExcludedUrl(request.url)) {
      request = request.clone({
        setHeaders: {
          Authorization: `${token}`
        }
      });
    }

    return next.handle(request).pipe(
      tap((event: HttpEvent<any>) => {
        // Check if it's an HttpResponse and update token
        // Skip token expiry check for excluded URLs (like login)
        if (event instanceof HttpResponse && !this.isExcludedTokenCheck(request.url)) {
            if (event.body && (event.body.status === 'TOKEN_EXPIRED' || event.body.status === 'SESSION_EXPIRED')) {
            this.handleTokenExpired(event.body);
          } else if (event.body && event.body.token && event.body.token.trim() !== '') {
            // Update token in session storage for each response if token exists and is not empty
            sessionStorage.setItem(AppConstants.SESSION_VAR_TOKEN, event.body.token);
          }
        }
      })
    );
  }

  private handleTokenExpired(responseBody?: any): void {
    // Show message - use server message if available, otherwise default message
    const message = responseBody?.message || 'Session expired. Please login again.';
    
    this.snackBar.open(message, 'Close', {
      duration: 3000,
      horizontalPosition: 'center',
      verticalPosition: 'top'
    });

    // Clear session storage
    sessionStorage.clear();

    // Redirect to login
    this.router.navigate(['/login']);
  }

  private isExcludedUrl(url: string): boolean {
    // Define the URLs that should be excluded from token insertion
    const excludedUrls = ['authenticate', '/customer/update'];
    // return true;
    return excludedUrls.some(excludedUrl =>
      url.includes(excludedUrl)
    );
  }

  /**
   * Add code if needed.
   * @param url 
   * @returns 
   */
  private isExcludedTokenCheck(url: string): boolean {
    return false;
  }
}
